import { useQuery } from 'react-query';
import axios from 'axios';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';

const useBusinessMerchant = (userId) => {
  const { token } = useContext(AuthContext);

  const fetchBusinessMerchant = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/users/merchants/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.merchant || null;
    } catch (error) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  };

  return useQuery(['businessMerchant', userId], fetchBusinessMerchant, {
    enabled: !!userId && !!token,
    retry: false,
  });
};

export default useBusinessMerchant;
